[
  {
    "url": "https://calendar.google.com/",
    "elements": [
      {
        "name": "Search meeting emails",
        "selector": "div[role='dialog'] div[data-email]:has(div[data-hovercard-id])",
        "multiple": "true",
        "keepEmpty": "true",
        "attributes": ["data-email"]
      },
      {
        "name": "Search meeting names",
        "selector": "div[role='dialog'] div[data-email] div[data-hovercard-id] span span",
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search meeting emails from data-text",
        "selector": "div[role='dialog'] div[data-text*='@']",
        "multiple": "true",
        "keepEmpty": "true",
        "attributes": ["data-text"]
      },
      {
        "name": "Search meeting emails from links",
        "selector": "div[role='dialog'] a[href^='mailto:']",
        "multiple": "true",
        "keepEmpty": "true",
        "attributes": ["href"]
      },
      {
        "name": "Search meeting title",
        "selector": "div[role='dialog'] div[data-text]>span[role='heading']",
        "multiple": "false"
      },
      {
        "name": "Search meeting time",
        "selector": "div[role='dialog'] div[data-text] + div",
        "multiple": "false"
      },
      {
        "name": "Add SW Button",
        "scenario": {
          "name": "addSwButtonToGoogleCalendar",
          "container": "div[role='dialog'] div[data-eventid]:not([data-loggingid]) div:has(> div[jsaction])"
        }
      },
      {
        "name": "Add SW Meeting Brief Container (new event)",
        "scenario": {
          "name": "addSwMeetingBriefToNewMeeting",
          "container": "div[role='dialog'] div[role='tabpanel'][aria-labelledby='tabEvent'] > span > div"
        }
      },
      {
        "name": "Add SW Meeting Brief Container (view event)",
        "scenario": {
          "name": "addSwMeetingBriefToViewMeeting",
          "container": "div[role='dialog'] div[data-open-edit-note='false'] div:has(> div[data-is-expanded])",
          "elementAfterWhichToInsertButton": "div[data-is-expanded]"
        }
      }
    ]
  },
  {
    "url": "https://calendar.google.com/.*/eventedit",
    "elements": [
      {
        "name": "Search meeting emails",
        "selector": "div[role='tabpanel'] div[data-email]:has(div[data-hovercard-id])",
        "multiple": "true",
        "keepEmpty": "true",
        "attributes": ["data-email"]
      },
      {
        "name": "Search meeting names",
        "selector": "div[role='tabpanel'] div[data-email] div[data-hovercard-id] span span",
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search meeting emails from data-text",
        "selector": "div[role='tabpanel'] div[data-text*='@']",
        "multiple": "true",
        "keepEmpty": "true",
        "attributes": ["data-text"]
      },
      {
        "name": "Search meeting emails from links",
        "selector": "div[role='tabpanel'] a[href^='mailto:']",
        "multiple": "true",
        "keepEmpty": "true",
        "attributes": ["href"]
      },
      {
        "name": "Add SW Meeting Brief Container (edit event)",
        "scenario": {
          "name": "addSwMeetingBriefToEditMeeting",
          "container": "div[role='tabpanel'] div:has(> div[jsname] div[aria-label='Description'])"
        }
      }
    ]
  },
  {
    "url": "https://outlook.live.com/calendar/",
    "elements": [
      {
        "name": "Search meeting emails",
        "selector": "div[data-app-section='CalendarItemPeek'] div[title='Attendee tracking'] .allowTextSelection",
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search meeting title",
        "selector": "div[data-app-section='CalendarItemPeek'] span[aria-label='Title']",
        "multiple": "false"
      },
      {
        "name": "Search meeting time",
        "selector": "div[data-app-section='CalendarItemPeek'] span[aria-label='Time']",
        "multiple": "false"
      },
      {
        "name": "Search meeting emails from event details",
        "selector": "div[data-app-section='ReadingPane'] div.fui-Persona[aria-label]",
        "multiple": "true",
        "keepEmpty": "true",
        "attributes": ["aria-label"]
      },
      {
        "name": "Search meeting title from event details",
        "selector": "div[data-app-section='ReadingPane'] div:has(button[aria-label='Exam icon'])+div>div>div>span:not([role='button'])",
        "multiple": "false"
      },
      {
        "name": "Search meeting time from event details",
        "selector": "div[data-app-section='ReadingPane'] div:has(div>i[data-icon-name='ClockRegular'])>div.allowTextSelection",
        "multiple": "false"
      },
      {
        "name": "Add SW Button",
        "scenario": {
          "name": "addSwButtonToOutlookCalendar",
          "container": "div[data-app-section='CalendarItemPeek'] div:has(>button[aria-label='View event'])",
          "elementBeforeWhichToInsertButton": "button[aria-label='View event']"
        }
      },
      {
        "name": "Add SW Button to event details",
        "scenario": {
          "name": "addSwButtonToOutlookCalendarDetails",
          "container": "div[data-app-section='ReadingPane'] div:has(>button[aria-label='Open in new window'])",
          "elementBeforeWhichToInsertButton": "button[aria-label='Open in new window']"
        }
      }
    ]
  }
]
